// AuthContext.js

import React, { createContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { handleNewUserVerification, handleVerifyToken } from '../state/auth/actions';
import { useDispatch } from 'react-redux'

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [user, setUser] = useState(null)
    const [isLoading, setIsLoading] = useState(true); // Add a loading state


    useEffect(() => {
        const localToken = localStorage.getItem('token');
        const token = history.location.pathname.split('/')[2]


        if (localToken) {
            dispatch(handleVerifyToken()).then(() => {
                setIsLoading(false);
            }).catch(() => {
                setIsLoading(false);
                history.push('/login')
            })
        } else {
            setIsLoading(false);
            //New Account ?
            if (token) {
                dispatch(handleNewUserVerification({ token }))
                    .then(res => setUser(res.payload))
                    .catch(err => history.push('/login'))
            } else {
                history.push('/login');

            }

        }
        // Set loading to false after verification
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    return (
        <AuthContext.Provider value={{ isLoading, user }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthProvider, AuthContext };
